export default __webpack_public_path__ + "static/media/rightDandiya.cd3c40ed.png";